module.exports = __webpack_public_path__ + "img/中国东海水产.2c3e422b.jpg";